module.exports = __webpack_public_path__ + "static/assets/de81ddb02e4b3bed0ac0c7e4a822944d.png";